export const moduleId = 'users'

export const filterTypes = {
  'ROLE': 'role',
  'STATUS': 'status',
  'ORG': 'org',
  'COUNTRY': 'countryCode'
}
